import css from './Content.module.css'

const Content = ({ children }) => <main className={css.main}>{children}</main>

export default Content
